import React from 'react';

// Users
const Users = React.lazy(() => import('pages/User/User'));
const UserAdd = React.lazy(() => import('pages/User/UserAdd'));
const UserDetail = React.lazy(() => import('pages/User/UserDetail'));
const UserEdit = React.lazy(() => import('pages/User/UserEdit'));
//.end#Users

const UsersRoutes = [
  // Users
  {
    path: '/users',
    exact: true,
    name: 'Danh sách nhân viên',
    function: 'SYS_USER_VIEW',
    component: Users,
  },
  {
    path: '/users/add',
    exact: true,
    name: 'Thêm mới nhân viên',
    function: 'SYS_USER_ADD',
    component: UserAdd,
  },
  {
    path: '/users/detail/:id',
    exact: true,
    name: 'Chi tiết nhân viên',
    function: 'SYS_USER_VIEW',
    component: UserDetail,
  },
  {
    path: '/users/edit/:id',
    exact: true,
    name: 'Chỉnh sửa nhân viên',
    function: 'SYS_USER_EDIT',
    component: UserEdit,
  },
  //.end#Users
];

export default UsersRoutes;
